exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".jobs-7de3498e{padding:20px 20px}.topPane-7905700e{background-color:#FFF5EB}.toolbar-64945a8a{display:flex;justify-content:flex-end}.toolbar-64945a8a .submitCTA-336cb269{margin:0px 0px auto 0px}.toolbar-64945a8a .deleteCTA-619bb3e1{margin:0px 10px}.toolbar-64945a8a>a{flex:0 1 auto;width:auto}.resolutionPane-c81f6246{height:340px;padding:20px 20px;border-radius:5px;background-color:#C8E6DC;display:flex;flex-wrap:wrap;overflow-y:scroll}.keyToResolve-73235735{display:flex;align-items:center;height:100%}.dupe-7c3de5ad{height:100%;border:2px solid #616161;display:flex;flex-direction:column;max-width:33%}\n", ""]);

// Exports
exports.locals = {
	"jobs": "jobs-7de3498e",
	"topPane": "topPane-7905700e",
	"toolbar": "toolbar-64945a8a",
	"submitCTA": "submitCTA-336cb269",
	"deleteCTA": "deleteCTA-619bb3e1",
	"resolutionPane": "resolutionPane-c81f6246",
	"keyToResolve": "keyToResolve-73235735",
	"dupe": "dupe-7c3de5ad"
};